import { render, staticRenderFns } from "./activeChatNavbar.vue?vue&type=template&id=1bdcaf9e&"
import script from "./activeChatNavbar.vue?vue&type=script&lang=js&"
export * from "./activeChatNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports